import $ from "jquery";
import { dateFormatter } from "../framework/dateFormatter";
import { peopleSearch } from "./peopleSearch";

let userCurrentPage = 0;
let userHasNextPage = false;
let userSearchTable;
let dataSet = [];
const searchPageSize = 10;

function init() {
    dateFormatter.initDatePicker();

    $("#userNext").click(function() {
        if (!userHasNextPage) return;
        $("#userPrevious").removeClass("disabled");
        userCurrentPage++;
        populateUserSearchTable();
    });
    $("#userPrevious").click(function() {
        if (userCurrentPage === 0) return;
        $("#userNext").removeClass("disabled");
        userCurrentPage--;
        populateUserSearchTable();
    });
    $(document).on("click", "#clearUserBtn", function() { $("#txtUser").val(""); });
    $("#user-search").submit(function(e) {
        e.preventDefault();
        populateUserSearchTable();
    });
    $(document).on("dblclick", "#userSearchTable tbody tr", function() {
        const data = userSearchTable.row(this).data();
        if (data === undefined) {
            return;
        }
        $("#txtUser").val(data[4]);
        $("#searchUserModal .close").click();
    });
}

function populateUserSearchTable() {
    const filters = {
        keyword: $("#userSearchKeyword").val(),
        active: true,
        inactive: true,
        pageSize: searchPageSize
    };
    $("#userSearchLoading").show();
    peopleSearch.getPeople(userCurrentPage, filters).done(function(results) {
        if (results !== null && results.people !== null && results.people.length !== 0) {
            dataSet = [];
            for (let i = 0; i < searchPageSize && i < results.people.length; i++) {
                dataSet.push([
                    results.people[i].id, results.people[i].aptifyId, results.people[i].firstName, results.people[i].lastName,
                    results.people[i].email
                ]);
            }
            userHasNextPage = results.people.length > searchPageSize;
        }

        userSearchTable = $("#userSearchTable").DataTable({
            "processing": true, // for show progress bar
            "serverSide": false, // for process server side
            "filter": false, // this is for disable filter (search box)
            //"orderMulti": false, // for disable multiple column at once
            "data": dataSet,
            "bLengthChange": false,
            "bPaginate": false,
            "PageLength": searchPageSize,
            "bInfo": false,
            destroy: true,
            "ordering": false,
            "columnDefs":
                [{
                    "targets": 0,
                    "visible": false,
                    "name": "id"
                }, {
                    "targets": 1,
                    "name": "aptifyId"
                }, {
                    "targets": 2,
                    "name": "firstName"
                }, {
                    "targets": 3,
                    "name": "lastName"
                }, {
                    "targets": 4,
                    "name": "email"
                }
                ]
        });
        $("#userSearchLoading").hide();
        updateUserResultsView();
    });
}

function updateUserResultsView() {
    if (!userHasNextPage) {
        $("#userNext").addClass("disabled");
    } else {
        $("#userNext").removeClass("disabled");
    }
    if (userCurrentPage === 0) {
        $("#userPrevious").addClass("disabled");
    } else {
        $("#userPrevious").removeClass("disabled");
    }
}

function getFilters() {
    return {
        startDate: $("#dateRangeStart").val(),
        endDate: $("#dateRangeEnd").val(),
        user: $("#txtUser").val(),
        role: $("#selectRole option:selected").text(),
        actionType: $("#actionTypeSelect option:selected").text(),
        service: $("#servicesSelect option:selected").text()
    };
}

export const activityReportFilters = {
    init: init,
    getFilters: getFilters
};